import { DefaultNodeModel } from "@projectstorm/react-diagrams";
import { v4 as uuidv4 } from "uuid";

export class ConditionNodeModel extends DefaultNodeModel {
  constructor({
    id = `ConditionNode_${uuidv4()}`,
    color = "rgb(128, 0, 128)",
    position = { x: 100, y: 100 },
    nodeProperties = { Name: "New Condition", Type: "Condition", Expression: "" },
  }) {
    super({
      id: id,
      name: nodeProperties.Name,
      color: color,
      extras: { properties: nodeProperties },
    });
    this.setPosition(position.x, position.y);
    this.addInPort("onTrigger");
    this.addInPort("Value");
    this.addOutPort("onConditionTrue");
    this.addOutPort("onConditionFalse");
  }
}

